// extracted by mini-css-extract-plugin
export default {"messages_container":"messages_messages_container__xZq2B"};